const clientIdStorage = {
  set: (value: string) => {
    localStorage.setItem("clientId", JSON.stringify(value));
  },
  get: (): string => {
    const value = localStorage.getItem("clientId");
    return (value && JSON.parse(value)) as string;
  },
  remove: () => {
    localStorage.removeItem("clientId");
  },
};

export default clientIdStorage;
